import { l as e, u as t } from "./useVoiceUpload-5WFawI3J.js";
import { lazy as n, memo as r, useCallback as i, useLayoutEffect as a, useState as o } from "react";
import { ComponentIdentifierEnum as s, FormFieldsEnum as c, notifySuspenseEnded as l, notifySuspenseStarted as u } from "@flowx/core-sdk";
import { clsx as ee } from "clsx";
import { usePositionStyles as te, useWrapperStyles as ne } from "@flowx/react-theme";
import { jsx as d } from "react/jsx-runtime";
//#region libs/sdk/react/src/lib/utils/lazyWithPreload.tsx
var f = (e) => {
	let t, i, a = () => i ??= e().then((e) => t = e, (e) => {
		throw i = void 0, e;
	}), s = n(a);
	return Object.assign(r((e) => {
		let [n] = o(() => t?.default ?? s);
		return /* @__PURE__ */ d(n, { ...e });
	}), { preload: a });
}, p = f(() => import("./FlxPage-Duu79woa.js"));
p.displayName = "LazyFlxPage";
var m = f(() => import("./FlxContainer-DJ0xKDQb.js"));
m.displayName = "LazyFlxContainer";
var h = f(() => import("./FlxButtonWrapper-BJdf07iV.js"));
h.displayName = "MemoFlxButtonWrapper";
var g = f(() => import("./FlxLink-BJLBwZ8L.js"));
g.displayName = "MemoFlxLink";
var _ = f(() => import("./FlxMessage-BO_HvRsK.js"));
_.displayName = "LazyFlxMessageWrapper";
var v = f(() => import("./FlxSeparatorWrapper-DNbOlBLl.js"));
v.displayName = "LazyFlxSeparatorWrapper";
var y = f(() => import("./FlxProgressBarWrapper-XZvwQck5.js"));
y.displayName = "LazyFlxProgressBarWrapper";
var b = f(() => import("./FlxBadgeWrapper-Ar67ZqB5.js"));
b.displayName = "LazyFlxBadgeWrapper";
var x = f(() => import("./FlxAvatarWrapper--mPaInUH.js"));
x.displayName = "LazyFlxAvatarWrapper";
var S = f(() => import("./FlxAlertWrapper-05iQ7iyR.js"));
S.displayName = "LazyFlxAlertWrapper";
var C = f(() => import("./FlxRatingWrapper-De-URANe.js"));
C.displayName = "LazyFlxRatingWrapper";
var w = f(() => import("./FlxSkeletonWrapper-tCQu5wbG.js"));
w.displayName = "LazyFlxSkeletonWrapper";
var T = f(() => import("./FlxProgressRingWrapper-cfaRYmgs.js"));
T.displayName = "LazyFlxProgressRingWrapper";
var E = f(() => import("./FlxEmptyStateWrapper-BP0ffhSf.js"));
E.displayName = "LazyFlxEmptyStateWrapper";
var D = f(() => import("./FlxStatsCardWrapper-C5YLJDbu.js"));
D.displayName = "LazyFlxStatsCardWrapper";
var O = f(() => import("./FlxTimelineWrapper-Bnc4gX0k.js"));
O.displayName = "LazyFlxTimelineWrapper";
var k = f(() => import("./FlxDescriptionListWrapper-CE27PZYt.js"));
k.displayName = "LazyFlxDescriptionListWrapper";
var A = f(() => import("./FlxTagGroupWrapper-L1ZSfu4c.js"));
A.displayName = "LazyFlxTagGroupWrapper";
var j = f(() => import("./FlxStepIndicatorWrapper-Bw5xRguX.js"));
j.displayName = "LazyFlxStepIndicatorWrapper";
var M = f(() => import("./FlxChartWrapper-B92qy8it.js"));
M.displayName = "LazyFlxChartWrapper";
var N = f(() => import("./FlxTooltipWrapper-CgwOOpYG.js"));
N.displayName = "LazyFlxTooltipWrapper";
var P = f(() => import("./FlxMarkdownWrapper-zIpBL9ZE.js"));
P.displayName = "LazyFlxMarkdownWrapper";
var F = f(() => import("./FlxChatWrapper-ChfRUIEo.js").then((e) => e.n));
F.displayName = "LazyFlxChatWrapper";
var I = f(() => import("./FlxText-CKwPIOck.js"));
I.displayName = "MemoFlxTextWrapper";
var re = f(() => import("./FlxFileUploadWrapper-5xweBHYS.js"));
re.displayName = "LazyFlxFileUploadWrapper";
var L = f(() => import("./FlxBulkFileUploadWrapper-DCcccDgQ.js"));
L.displayName = "LazyFlxBulkFileUploadWrapper";
var R = f(() => import("./FlxDownloadWrapper-D1GreGN0.js"));
R.displayName = "LazyFlxDownloadWrapper";
var z = f(() => import("./FlxCardWrapper-DFVVOSwL.js"));
z.displayName = "LazyFlxCardWrapper";
var B = f(() => import("./FlxImage-990mAjaD.js"));
B.displayName = "LazyFlxImageWrapper";
var V = f(() => import("./FlxDocumentViewerWrapper-GtF0BTN-.js"));
V.displayName = "LazyFlxDocumentViewerWrapper";
var H = f(() => import("./FlxForm-DW4y9zfn.js"));
H.displayName = "LazyFlxFormWrapper";
var U = f(() => import("./FlxInputWrapper-BIV9tMOR.js"));
U.displayName = "LazyFlxInputWrapper";
var W = f(() => import("./FlxTextAreaWrapper-GHdcwAFa.js"));
W.displayName = "LazyFlxTextAreaWrapper";
var G = f(() => import("./FlxSelectWrapper-CefetFgA.js"));
G.displayName = "LazyFlxSelectWrapper";
var K = f(() => import("./FlxMultiSelectWrapper-DMBKReJz.js"));
K.displayName = "LazyFlxMultiSelectWrapper";
var q = f(() => import("./FlxRadioGroupWrapper-BZjV2Q_d.js"));
q.displayName = "LazyFlxRadioGroupWrapper";
var J = f(() => import("./FlxCheckboxGroupWrapper-CVTLrln_.js"));
J.displayName = "LazyFlxCheckboxGroupWrapper";
var Y = f(() => import("./FlxSwitchWrapper-DgPMORm5.js"));
Y.displayName = "LazyFlxSwitchWrapper";
var X = f(() => import("./FlxDatePickerWrapper-DMQpawke.js"));
X.displayName = "LazyFlxDatePickerWrapper";
var Z = f(() => import("./FlxSliderWrapper-C6i5Lipd.js"));
Z.displayName = "LazyFlxSliderWrapper";
var ie = f(() => import("./FlxSegmentedButtonWrapper-zUxFbccM.js"));
ie.displayName = "LazyFlxSegmentedButtonWrapper";
var ae = f(() => import("./FlxCollection-Mle-P1ZZ.js"));
ae.displayName = "LazyFlxCollection";
var oe = f(() => import("./FlxCollectionPrototype-Cc_cih2z.js"));
oe.displayName = "LazyFlxCollectionPrototype";
var se = f(() => import("./src-BF3nY99n.js").then((e) => e.k));
se.displayName = "LazyFlxModalWrapper";
var ce = f(() => import("./FlxTabBarWrapper-5sXi8mbI.js"));
ce.displayName = "LazyFlxTabBarWrapper";
var le = f(() => import("./FlxStepperWrapper-CdIz0OSg.js"));
le.displayName = "LazyFlxStepperWrapper";
var ue = f(() => import("./FlxTableWrapper-CzXK6ziM.js"));
ue.displayName = "LazyFlxTableWrapper";
var Q = f(() => import("./FlxTaskManagementWrapper-Bg1WMBQF.js"));
Q.displayName = "LazyFlxTaskManagementWrapper";
var de = f(() => import("./FlxProcessRendererWrapper-CNemy7-C.js"));
de.displayName = "LazyFlxProcessRendererWrapper";
var fe = f(() => import("./src-BF3nY99n.js").then((e) => e.F).then((e) => ({ default: e.FlxRuntimeCustomComponent })));
fe.displayName = "LazyFlxRuntimeCustomComponent";
var pe = {
	[s.LINK]: g,
	[s.BUTTON]: h,
	[s.MESSAGE]: _,
	[s.SEPARATOR]: v,
	[s.TOOLTIP]: N,
	[s.PROGRESS_BAR]: y,
	[s.BADGE]: b,
	[s.AVATAR]: x,
	[s.ALERT]: S,
	[s.RATING]: C,
	[s.SKELETON]: w,
	[s.PROGRESS_RING]: T,
	[s.EMPTY_STATE]: E,
	[s.STATS_CARD]: D,
	[s.TIMELINE]: O,
	[s.DESCRIPTION_LIST]: k,
	[s.TAG_GROUP]: A,
	[s.STEP_INDICATOR]: j,
	[s.CHART]: M,
	[s.MARKDOWN]: P,
	[s.CHAT]: F,
	[s.TEXT]: I,
	[s.FILE_UPLOAD]: re,
	[s.FILE_DOWNLOAD]: R,
	[s.BULK_FILE_UPLOAD]: L,
	[s.IMAGE]: B,
	[s.DOCUMENT_PREVIEW]: V,
	[s.FORM]: H,
	[s.TASK_MANAGEMENT]: Q,
	[s.PROCESS_RENDERER]: de
}, me = {
	[s.PAGE]: p,
	[s.CONTAINER]: m,
	[s.CARD]: z,
	[s.COLLECTION]: ae,
	[s.COLLECTION_PROTOTYPE]: oe,
	[s.MODAL]: se,
	[s.TAB_BAR]: ce,
	[s.ZONE]: m,
	[s.STEPPER]: le,
	[s.TABLE]: ue
}, he = {
	[c.INPUT]: U,
	[c.TEXTAREA]: W,
	[c.SELECT]: G,
	[c.MULTI_SELECT]: K,
	[c.RADIO]: q,
	[c.CHECKBOX]: J,
	[c.SWITCH]: Y,
	[c.DATEPICKER]: X,
	[c.SLIDER]: Z,
	[c.SEGMENTED_BUTTON]: ie
}, ge = (e = []) => e.flatMap((e) => [e.componentIdentifier, ...ge(e.templateConfig)]), _e = {
	...me,
	...pe,
	...he
}, ve = (e) => Promise.allSettled([...new Set(ge(e).map((e) => _e[e]))].map((e) => e?.preload).filter((e) => e !== void 0).map((e) => e())), ye = (e) => {
	if (!("displayOptions" in e)) return {};
	let t = e.displayOptions.style;
	return "componentIdentifier" in e && e.componentIdentifier === s.CHAT && t?.fill || t;
}, $ = ({ config: n, children: r, ref: a }) => {
	let o = ye(n), { className: s, ref: c } = ne({
		styles: o,
		componentIdentifier: "componentIdentifier" in n ? n.componentIdentifier : void 0
	}), l = i((e) => {
		c(e), typeof a == "function" ? a(e) : a && (a.current = e);
	}, [c, a]), u = te({ styles: o?.position || null }), f = t({
		config: n,
		expression: "displayOptions" in n && "flowxProps" in n.displayOptions && n.displayOptions.flowxProps?.hide || "",
		logType: "hide"
	}), p = e(n);
	return f || p ? null : /* @__PURE__ */ d("div", {
		ref: l,
		className: ee(s, u),
		children: r
	});
};
$.displayName = "FlxTreeNodeWrapper";
//#endregion
//#region libs/sdk/react/src/components/sdk/tree-node/SuspensePending.tsx
function be({ children: e = null }) {
	return a(() => (u(), l), []), e;
}
//#endregion
export { he as a, me as i, $ as n, ve as o, pe as r, be as t };
